.map {
    border-radius: 6px;
    height: 330px;
    margin: 2em 1em;
}
